import config from "@/common/config";

import ApiService from "./api.service";

/**
 * @param {string} content
 *
 * @returns {string}
 */
export function wrapParagraphs(content) {
  return content.replace(
    /§[\s(&nbsp;)]*(\d+(-\d+)?)(\.[\w.]+)?/g,
    (match, paragraph) =>
      `<a href="#" class="dsn-paragraph" data-paragraph="${paragraph}">${match}</a>`
  );
}

/**
 *
 * @param {HTMLElement} el
 *
 * @returns {string|undefined}
 */
export function getParagraph(el) {
  return el.dataset["paragraph"];
}

export default {
  VERSION: config.api.versions.v2,

  /**
   * Fetches tree list of rules.
   *
   * @typedef {{
   *  name: string,
   *  link?: string,
   *  children?: Rule[]
   * }} Rule
   *
   * @returns {Promise<Rule[]>}
   */
  async fetchTreeList() {
    const response = await ApiService.get("/workshop/spelling-rules", this.VERSION);

    return response.data.data.treeList;
  },

  /**
   * Fetches HTML blob of one or more rules
   *
   * @param {string} paragraph A single paragraph (`1`) or a range (`1-6`) can be specified.
   *
   * @returns {Promise<{ title: string, html: string }>} Title and HTML containing one or more rules.
   */
  async fetchRule(paragraph) {
    const response = await ApiService.get(`/workshop/spelling-rules/${paragraph}`, this.VERSION);

    return response.data.data;
  }
};
